export var SupplierInvoiceStatus;
(function (SupplierInvoiceStatus) {
    SupplierInvoiceStatus["PENDING"] = "pending";
    SupplierInvoiceStatus["EXTRACTING"] = "extracting";
    SupplierInvoiceStatus["PROCESSED"] = "processed";
    SupplierInvoiceStatus["VALIDATED"] = "validated";
    SupplierInvoiceStatus["ERROR"] = "error";
    SupplierInvoiceStatus["AWAITING_QUOTA"] = "awaitingQuota";
    /** Soft-deleted (Admin OCR / duplicate cleanup); mirrors delivery notes. */
    SupplierInvoiceStatus["DELETED"] = "deleted";
})(SupplierInvoiceStatus || (SupplierInvoiceStatus = {}));
/** Statuses that occupy a document quota slot (aligned with delivery-note pipeline). */
export const PENDING_VALIDATION_SUPPLIER_INVOICE_STATUSES = [
    SupplierInvoiceStatus.PENDING,
    SupplierInvoiceStatus.EXTRACTING,
    SupplierInvoiceStatus.PROCESSED,
];
/** Statuses from which extraction may claim the document. */
export const CLAIMABLE_SUPPLIER_INVOICE_STATUSES = [
    SupplierInvoiceStatus.PENDING,
    SupplierInvoiceStatus.AWAITING_QUOTA,
    SupplierInvoiceStatus.ERROR,
];
/** Statuses from which an invoice may be re-processed as a delivery note; EXTRACTING converts when extraction ends. */
export const CONVERTIBLE_TO_DELIVERY_NOTE_SUPPLIER_INVOICE_STATUSES = [
    SupplierInvoiceStatus.PENDING,
    SupplierInvoiceStatus.AWAITING_QUOTA,
    SupplierInvoiceStatus.PROCESSED,
    SupplierInvoiceStatus.ERROR,
];
/**
 * True when Tipi may treat this referenced note as linked for money reconciliation (step 4).
 * Legacy working-copy notes with `deliveryNoteId` but no `linkStatus` count as confident.
 */
export const isConfidentSupplierInvoiceDeliveryNoteLink = (note) => {
    if (!note.deliveryNoteId) {
        return false;
    }
    if (note.linkStatus === undefined) {
        return true;
    }
    return note.linkStatus === 'matched' || note.linkStatus === 'matched_manual';
};
export const defaultSupplierInvoiceData = {
    supplierInvoiceId: '',
    organizationId: '',
    imagePaths: [],
    status: SupplierInvoiceStatus.PENDING,
    referencedDeliveryNotes: [],
    confidentDeliveryNoteIds: [],
    lines: [],
    general: {},
    vats: [],
    vatRemovedFromLinePrices: false,
};
//# sourceMappingURL=SupplierInvoiceEntity.js.map